import {createContext, Dispatch, SetStateAction, useContext} from "react";
import {UserFragmentFragment} from "@/graphql/graphql.ts";

export interface UserDataIFace {
  user?: UserFragmentFragment | null
  permissions: string[]
  isLoading: boolean
}

export const UserData = createContext<UserDataIFace>({
  permissions: [],
  isLoading: false
});

export const SetUserData = createContext<
  Dispatch<SetStateAction<UserDataIFace>>
>(() => undefined);

export const useSetUserData = () => useContext(SetUserData);

export const useUserData = () => useContext(UserData);
